<template>
    <div>
    
        <el-tabs v-model="tabsKey" @tab-click="handleClick">
            <el-tab-pane label="查詢" name="search">
                <search @detailTabs="detailTabs" />
            </el-tab-pane>
            <el-tab-pane label="詳細" name="detail" v-if="isShowDetail">
                <detail :permissionKey="permissionKey"  />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import search from './Permission/search'
    export default {
        name: 'Permission',
        components: {
            search
           
        },
        data() {
            return {
                  isShowDetail: false,
                tabsKey: 'search',
                permissionKey: ''
            }
        },
        methods: {
              detailTabs(permissionKey){
                this.isShowDetail = true
                this.tabsKey ="detail"
                this.permissionKey = permissionKey
            },
            handleClick(tab, event){
                if (tab.name == 'search') {
                    this.isShowDetail = false
                }
            },
            back(){
                this.isShowDetail = false
            }
        },
    }
</script>